import { useSearch } from '@tanstack/react-router'
import { useState } from 'react'

import { useDocumentOCRResultStore } from '../../../store'

export const useCurrentDocument = () => {
  const { taskId: taskIdSearchParam } = useSearch({ from: '/process-document/review/$jobId' })

  const [currentPage, setCurrentPage] = useState(1)

  const { getCurrentOCRResult } = useDocumentOCRResultStore()

  const currentOCRResult = getCurrentOCRResult(taskIdSearchParam)
  const currentDocumentName = currentOCRResult?.fileName
  const imgUrls = currentOCRResult?.imgUrls || []
  const totalPages = imgUrls.length

  const handleChangePage = (page: number) => {
    setCurrentPage(page)
  }

  return { currentDocumentName, imgUrls, currentPage, totalPages, handleChangePage }
}
